module.exports = __webpack_public_path__ + "assets/948bd9ea69f2c387ac78d728617a6a0f.mp3";